import type { SVGProps } from 'react';

interface NutsIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function NutsIcon({ className, ...props }: NutsIconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M4.22225 0.0133747C5.91709 -0.117919 7.63618 0.725682 8.50482 2.18048C9.20367 3.35005 9.22944 4.18611 10.2861 5.30135C11.5064 6.58863 12.2932 6.61882 13.6924 7.40507C18.8163 10.2815 14.561 18.2708 9.15971 15.3793C7.12075 14.2882 7.21929 12.3641 5.82765 10.7915C4.56334 9.3609 3.74928 9.38957 2.26971 8.53692C-1.59142 6.31246 -0.252836 0.358964 4.22225 0.0133747ZM3.08074 1.13616C2.42433 1.28859 2.55319 2.37365 3.29297 2.40534C4.2268 2.44458 4.21771 0.872067 3.08074 1.13616ZM6.6311 2.59851C7.34511 1.8862 6.05807 0.939978 5.59571 1.75491C5.19549 2.45967 6.07778 3.15085 6.6311 2.59851ZM4.41023 3.85108C3.87055 4.48642 4.82863 5.42208 5.41379 4.73694C6.05049 3.99143 4.8923 3.28365 4.41023 3.85108ZM7.61798 4.67355C6.98735 4.81541 7.01767 5.82653 7.69833 5.92311C8.79436 6.07855 8.72918 4.42455 7.61798 4.67355Z" fill="currentColor" />
    </svg>
  );
}
